import { useEffect, useRef, useState } from "react";

export default function Nosotros() {
  const mobileTitleRef = useRef(null);
  const desktopTitleRef = useRef(null);
  const [blockWidth, setBlockWidth] = useState(null);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const measure = () => {
      const m = mobileTitleRef.current
        ? mobileTitleRef.current.getBoundingClientRect().width
        : 0;
      const d = desktopTitleRef.current
        ? desktopTitleRef.current.getBoundingClientRect().width
        : 0;
      const w = Math.max(m, d);
      if (w) setBlockWidth(Math.ceil(w));
    };

    // Measure now & on resize
    measure();
    const ro = new ResizeObserver(measure);
    if (mobileTitleRef.current) ro.observe(mobileTitleRef.current);
    if (desktopTitleRef.current) ro.observe(desktopTitleRef.current);
    window.addEventListener("resize", measure);

    return () => {
      ro.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, []);

  return (
    <section
      className="bg-dark-gray relative text-white px-12 md:px-4 py-8 md:py-16 bg-cover bg-center"
      style={{ backgroundImage: "url('/images/fondoBlanco.webp')" }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-60"></div>

      <div className="relative max-w-6xl mx-auto">
        {/* TITLE (centered; shrink-to-fit so we can measure its width) */}
        <h2 className="text-2xl md:text-6xl font-extrabold leading-snug text-white mb-4">
          {/* Mobile title */}
          <div
            ref={mobileTitleRef}
            className="w-fit mx-auto flex flex-col items-center md:hidden"
          >
            <span className="bg-primary-green text-white px-3 py-1 rounded inline-block">
              SOLUCIONES
            </span>
            <span className="bg-primary-green text-white px-3 py-1 rounded inline-block">
              PROFESIONALES EN
            </span>
            <span className="bg-primary-green text-white px-3 py-1 rounded inline-block">
              FIBRA DE CARBONO
            </span>
            <span className="bg-primary-green text-white px-3 py-1 rounded inline-block">
              Y RESINAS EPÓXICAS
            </span>
          </div>

          {/* Desktop title */}
          <div
            ref={desktopTitleRef}
            className="w-fit mx-auto hidden md:flex flex-col items-center"
          >
            <span className="bg-primary-green text-white px-3 py-1 rounded inline-block">
              SOLUCIONES PROFESIONALES
            </span>
            <span className="bg-primary-green text-white px-3 py-1 rounded inline-block">
              EN FIBRA DE CARBONO
            </span>
            <span className="bg-primary-green text-white px-3 py-1 rounded inline-block">
              Y RESINAS EPÓXICAS
            </span>
          </div>
        </h2>

        {/* Everything below uses the SAME width as the title */}
        <div
          className="mx-auto"
          style={{ width: blockWidth ? `${blockWidth}px` : "auto" }}
        >
          {/* Subtitle */}
          <p className="text-center text-2xl md:text-4xl text-gray-300 mb-8">
            Insumos de alta calidad para el mercado mayorista en México
          </p>

          {/* Content (image + text) */}
          <div className="flex flex-col md:flex-row items-start gap-8">
            {/* Left: Image */}
            <div className="w-full md:w-1/2">
              <img
                src="/images/FondoInicioWeb2.png"
                alt="Carbon Fiber"
                className="rounded-lg shadow-lg w-full object-cover"
              />
            </div>

            {/* Right: Text */}
            <div className="w-full md:w-1/2 space-y-4 text-xl md:text-2xl text-left">
              <p>
                <strong>Omova Carbon Fiber</strong> es una marca mexicana
                especializada en la <strong>venta mayorista</strong> de fibra de
                carbono, resinas epóxicas y complementos para diversos sectores
                incluyendo: automotriz, deportivo y manufactura avanzada.
              </p>
              <p>
                Operamos exclusivamente en línea con una{" "}
                <strong>plataforma diseñada para mayoristas</strong>, ofertando
                nuestros productos en presentaciones por volumen y envíos
                seguros a todo México.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
